const DynamicUpdateCondition = {
  IsNot: 1,
  Is: 2
};

export default DynamicUpdateCondition;
